// extracted by mini-css-extract-plugin
export default {"map":"_2zCktwCsSFaUcxxEWYLnCk","stats":"A01K4NPw-R2Q0pbzC_4Xu","mapChart":"_32QcvoqqOV5xz8rqY9eKqj"};